<template>
    <div class="underlay" @mousedown="underlayClick" v-if="modalSettings">
        <transition name="slide-fade">
            <div class="sidebar" :class="{wide: settings.wide}">
                <div class="sidebar_top">
                    <div class="close" @click="onCancelAction">
                        <img src="@/assets/icons/ic_close_white.svg" alt="Close">
                    </div>
                    <h2 class="sidebar_title">{{settings.title}}</h2>
                    <h3 class="sidebar_description" v-if="settings.description">{{settings.description}}</h3>
                    <form>
                        <ul class="sidebar_content">
                            <li v-for="(item, index) in settings.input" :key="index">
                                <div class="icon-wrap">
                                    <img :src='getImgSrc(item.img)' alt="ico" v-if="item.img">
                                </div>

                                <md-field
                                        v-if="item.type == 'tel'"
                                        class="phone-custom"
                                        ref="phoneField"
                                        :class="{'md-invalid': $v.phone.$dirty && $v.phone.$invalid}"
                                >
                                    <label>{{item.label}}</label>
                                    <vue-tel-input
                                            id="tooltip-phone"
                                            v-model="item.value"
                                            placeholder=""
                                            :inputOptions="{showDialCode: true}"
                                            @input="onInputPhoneField"
                                            @blur="onBlurPhoneField"

                                    ></vue-tel-input>
                                    <span class="md-error">{{ translate('bi_validation_Phone') }}</span>
                                    <b-tooltip target="tooltip-phone" variant="info">Ex: +38 050 777-77-77</b-tooltip>
                                    <span hidden>{{phone = item.value || '  '}}</span>
                                </md-field>

                                <md-field :class="item.class" v-else>
                                    <label>{{item.label}}</label>
                                    <md-input :maxlength="item.count" :type="item.type" v-model="item.value"
                                              :autocomplete="item.type" :keyup="validate(item)"
                                              @input="validate(item)"></md-input>
                                    <span class="md-error">{{translate('ThereIsAnError')}}</span>
                                </md-field>
                                <div @click="onRightImageClick(item)" class="icon-wrap-right" v-if="item.right_img">
                                    <img :src='getImgSrc(item.right_img)' alt="ico">
                                </div>
                            </li>
                        </ul>
                    </form>
                </div>
                <div v-if="settings.checkboxes">
                    <b-form-checkbox
                            v-for="(item, index) in settings.checkboxes" :key="index"
                            v-model="item.checked">{{item.title}}
                    </b-form-checkbox>
                </div>
                <div v-if="settings.dropdowns">
                    <div v-for="(dropdown, dropdownIndex) in settings.dropdowns" :key="dropdownIndex"
                         class="dropdown_sites"
                    style="margin-top: 12px;">
                        <label>{{dropdown.name}}</label>
                        <b-dropdown :text="dropdown.items[dropdown.active].name">
                            <b-dropdown-item v-for="(item, index) in dropdown.items" :key="index"
                                             v-on:click="dropdown.active = index">
                                <span>{{item.name}}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>


                <div v-if="settings.dropdown" class="dropdown_sites">
                    <b-dropdown :text="dropdownChoose ? dropdownChoose.tag : settings.dropdown[0].tag">
                        <b-dropdown-item v-for="(item, index) in settings.dropdown" :key="index"
                                         v-on:click="changeDropdownActiveElement(item)">
                            <span>{{item.tag}}</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="invite_managers" v-if="settings.managers">
                    <inviteManagers
                            @cancel="onCancelAction"
                            :settings="settings.managers"
                    ></inviteManagers>
                </div>

                <div class="photo_uploader" v-if="settings.photo">
                    <photoUploader
                            :preview="settings.photo.preview"
                            :site-uid="settings.site_uid"
                            v-on:uploaded="changeSource"
                            v-on:removed="removeSource"
                    ></photoUploader>
                </div>

                <div class="analytic_filter" v-if="settings.analyticFilter">
                    <analyticFilter
                            :is-visible-dropdown="settings.isVisibleDropdown"
                            :date-from="settings.dateFrom"
                            :date-to="settings.dateTo"
                    ></analyticFilter>
                </div>

                <div class="comments" v-if="settings.comments">
                    <comments
                            :comments="settings.comments"
                            :date-from="settings.dateFrom"
                            :date-to="settings.dateTo"
                    ></comments>
                </div>
                <div class="votes" v-if="settings.votes">
                    <votesSidebar
                            :settings="{closeHandler: onCancelAction}"
                    ></votesSidebar>
                </div>
                <div class="help-center" v-if="settings.helpCenter">
                    <helpCenter></helpCenter>
                </div>

                <div class="sidebar_bottom">
                    <button block v-for="(btn, index) in settings.buttons" :key="index"
                            :class="[{'disabled': btn.spinner}, btn.classList]" :disabled="btn.spinner"
                            class="primaryButton"
                            @click="onBtnAction(btn)">
                        <b-spinner v-if="btn.spinner" small></b-spinner>
                        <span v-else>{{btn.text}}</span>
                    </button>
                    <button block v-if="settings.cancel"
                            :class="settings.cancel.classList"
                            class="primaryButton reverse"
                            @click="onCancelAction">
                        {{translate('Cancel')}}
                    </button>

                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import {MdField} from 'vue-material/dist/components'
    import '@/assets/css/MdField.css'
    import {VueTelInput} from 'vue-tel-input'
    import {validationMixin} from 'vuelidate'

    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import inviteManagers from '@/components/widgets/inviteManagers';
    import photoUploader from '@/components/widgets/photoUploader';
    import helpCenter from "@/components/widgets/helpCenter";
    import analyticFilter from '@/components/widgets/analyticFilter';
    import comments from '@/components/widgets/comments';
    import votesSidebar from '@/components/widgets/votesSidebar';
    import {isPhoneValid, phoneValidator} from '@/helpers/customValidators'

    Vue.use(MdField)

    export default {
        name: 'customModalDialog',

        mixins: [errorMixin, validationMixin],

        data() {
            return {
                modalSettings: !_.isEmpty(this.settings),
                currentPhoneCountry: null,
                phone: '',
                dropdownChoose: null
            }
        },

        components: {
            inviteManagers,
            analyticFilter,
            photoUploader,
            VueTelInput,
            comments,
            helpCenter,
            votesSidebar,
        },

        validations: {
            phone: {
                phone: phoneValidator
            },
        },

        watch: {
            settings(newValue) {
                this.modalSettings = !_.isEmpty(newValue)
            },

            phone(newValue) {
                this.$nextTick(() => {
                    if (this.phone && this.settings) {
                        this.$refs.phoneField[0].fieldClasses['md-focused'] = newValue.length > 0
                        if (newValue.length > 0) {
                            this.$refs.phoneField[0].$el.classList.add('md-has-value')
                        } else {
                            this.$refs.phoneField[0].$el.classList.remove('md-has-value')
                        }
                    }
                })
            },
            modalSettings(newValue) {
                document.body.style.overflow = newValue ? 'hidden' : 'auto'
            },
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        validate: true
                    }
                }
            },
        },

        methods: {

            changeSource(data) {
                this.$emit('changeSource', data)
            },

            removeSource(data) {
                this.$emit('removeSource', data)
            },

            changeDropdownActiveElement(item) {
                this.dropdownChoose = item
                this.settings.dropdownChoose = item
            },

            onBlurPhoneField() {
                let validate = this.phone.replace(/[' ']/g, '').replace(/-/g, '')
                if (isPhoneValid(validate)) {
                    this.$refs.phoneField[0].$el.classList.remove('md-invalid')
                } else {
                    this.$refs.phoneField[0].$el.classList.add('md-invalid')
                }
            },

            onInputPhoneField(value, obj) {
                this.phone = value
                this.currentPhoneCountry = `+${obj.country.dialCode}`
                this.$v.phone.$touch()
            },

            validate(item) {
                if (item.type == 'tel' && item.value.length) {
                    if (item.value.match(/^\+[0-9]{5,20}$/g)) {
                        item.class = ''
                        this.settings.validate = true;
                    } else {
                        item.class = ' md-invalid '
                        this.settings.validate = false;
                    }
                } else if (item.require) {
                    if (item.value) {
                        console.log('test1')
                        item.class = ' '
                    } else {
                        console.log('test2')
                        item.class = ' md-invalid '
                    }
                } else {
                    item.class = ' '
                }
            },

            getImgSrc(name) {
                if (name) {
                    return require(`@/assets/icons/${name}`)
                } else {
                    return null;
                }
            },

            async onCancelAction() {
                this.modalSettings = false
                this.dropdownChoose = null
                if (this.settings.onCancelAction) {
                    try {
                        await this.settings.onCancelAction(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    } finally {
                        this.phone = ''
                    }
                }
            },

            async onBtnAction(conf) {
                if (this.settings.input) {
                    for (var i = 0; this.settings.input.length > i; i++) {
                        var item = this.settings.input[i]
                        if (item.require && !item.value) {
                            this.validate(item)
                            item.value = ' '
                            item.value = ''
                            return
                        }
                    }
                }
                try {
                    await conf.action(this.settings)
                    // TODO: confirm modal
                    if (conf.cleanData != false) {
                        this.modalSettings = false
                        this.dropdownChoose = null
                    }
                } catch (error) {
                    this.showErrorModal(error.message)
                } finally {
                    this.phone = ''
                }
            },

            onRightImageClick(inputItem) {
                if (inputItem.rightClickHandler) {
                    inputItem.rightClickHandler()
                }
            },
            underlayClick(e) {
                if (($(".underlay").has(e.target).length === 0)) {
                    this.onCancelAction()
                }
            }

        },
        mounted() {
            setTimeout(() => {
                this.onBlurPhoneField()
            }, 0)
        }
    }
</script>

<style>

    .sidebar_content .vue-tel-input {
        position: absolute;
        z-index: 2;
        border: none;
        width: 100%;
    }

    .underlay {
        background-color: rgba(0, 0, 0, 0.06);
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .sidebar_content .vue-tel-input:focus {
        outline: none;
    }

    .sidebar_content .vue-tel-input:focus-within {
        border: none;
        box-shadow: none;
    }

    .sidebar_content .vti__input {
        background: none;
    }

    .sidebar_content .vti__dropdown {
        top: -2px;
    }

    .sidebar_content.vti__dropdown-item {
        width: 100%;
        margin: 0;
    }

    .sidebar_content .md-field .md-count,
    .sidebar_content .md-field .md-helper-text {
        color: #6D6D6D;
    }

    .dropdown_sites {
        position: relative;
        padding-left: 31px;
    }

    .dropdown_sites .btn-secondary,
    .dropdown_sites .btn-secondary:focus,
    .dropdown_sites .btn-secondary.focus {
        box-shadow: none !important;
        word-break: break-all;
        white-space: initial;
        text-align: left;
        padding-left: 0;
    }

    .dropdown_sites > .dropdown {
        width: 100%;
        max-width: 316px;
    }

    .dropdown_sites > .dropdown:before {
        content: " ";
        z-index: 1;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #3F405C;
        width: 100%;
        height: 1px;
    }

    .dropdown_sites .dropdown-toggle::after {
        position: absolute;
        right: 0;
    }

    .dropdown_sites .dropdown-menu.show {
        right: 0;
        left: 0;
        overflow-y: scroll;
        height: 150px;
    }

    .dropdown_sites .dropdown-menu.show li {
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .dropdown_sites .dropdown-menu.show li a {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .dropdown_sites .dropdown-menu.show li a span {
        word-break: break-all;
        white-space: initial;
    }

    .dropdown_sites .dropdown-menu.show li a:active {
        background-color: #2F2F2F;
    }

    .dropdown_sites > .dropdown .btn-secondary {
        background: none !important;
        border: 0;
        display: flex;
        align-items: center;
        color: #2F2F2F;
        font-weight: 500;
        position: relative;
        font-size: 16px;
    }

    /* ## */

    .sidebar {
        height: 100vh;
        overflow-x: hidden;
        background: #fff;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: 400px;
        /*min-width: 350px;*/
        padding: 25px;
        z-index: 9999;
        box-shadow: -.5vw 0 .5vw 0 rgba(0, 0, 0, 0.25);
    }
    .sidebar.wide {
        width: 700px;
        max-width: 100%;
    }

    .sidebar .close {
        position: absolute;
        top: 0;
        right: 0;
    }

    .sidebar .close img {
        width: 17px;
        height: 17px;
    }

    .sidebar_top {
        position: relative;
        padding-top: 2vw;
    }

    .sidebar_title {
        font-size: 18px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 1vw;
    }

    .sidebar_description {
        font-size: 14px;
        line-height: 22px;
        margin-top: 1vw;
        margin-bottom: 1vw;
        font-weight: 700;
    }

    .sidebar_content li {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0;
        margin-bottom: 15px;
    }

    .sidebar_content .icon-wrap {
        min-width: 34px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sidebar_content .icon-wrap-right {
        color: #2F2F2F;
        min-width: 28px;
        margin-left: 8px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 2px solid #2F2F2F;
        border-radius: 4px;
    }

    .sidebar_content li img {
        margin-right: 8px;
        max-width: 24px;
        max-height: 24px;
        opacity: .5;
    }

    .sidebar_content .icon-wrap-right img {
        margin-right: 0px;
        max-width: 20px;
        max-height: 20px;
        opacity: 1;
    }

    .sidebar_bottom {
        margin-top: 20px;
    }

    .sidebar_bottom button {
        width: 100%;
        margin-top: 5px;

        /*padding: 12px;*/
        /*background: transparent;*/
        /*border: 0;*/
        /*box-shadow: inset 0 0 0 2px #2F2F2F;*/
        /*color: #2F2F2F;*/
        /*font-weight: 600;*/
        /*font-size: 14px;*/
        /*line-height: 24px;*/
        /*border-radius: 4px;*/
        /*margin-bottom: 10px;*/
    }

    /*.sidebar_bottom button span {*/
    /*    font-weight: 600;*/
    /*}*/

    .sidebar_bottom button.disabled {
        cursor: no-drop;
    }

    /*.sidebar_bottom button.invert_btn {*/
    /*    background: #2F2F2F;*/
    /*    color: #fff;*/
    /*}*/


    /*.sidebar_content .md-field label {*/
    /*  top: 1.25vw;*/
    /*  font-size: .9vw;*/
    /*  line-height: 1vw;*/
    /*  white-space: nowrap;*/
    /*}*/
    /*.sidebar_content .md-field.md-focused label,*/
    /*.sidebar_content .md-field.md-focused label,*/
    /*.sidebar_content .md-field.md-has-value label {*/
    /*  top: 0;*/
    /*}*/
    .sidebar_content .md-field {
        /*margin: 0.2vw 0 1.2vw;*/
        /*min-height: 2vw;*/
        /*padding-top: 1vw;*/
    }

    .md-field.md-invalid .md-error {
        color: red;
    }

    .sidebar_content .md-field .md-input,
    .sidebar_content .md-field .md-textarea {
        font-size: 14px;
        line-height: 22px;
    }

    .sidebar_content .md-field .md-count {
        /*font-size: 0.65vw;*/
        /*height: 1.05vw;*/
        /*bottom: -1.1vw;*/
        /* display: none; */
        left: auto;
        right: 0;
    }


    @media screen and (max-width: 1000px) {
        .sidebar {
            width: 97vw;
            padding: 25px 15px 10px;
            box-shadow: -10px 0 14px 0 rgba(0, 0, 0, 0.25);
        }

        .sidebar .close img {
            width: 24px;
        }

        .sidebar_top {
            padding-top: 30px;
        }

        .sidebar_title {
            font-size: 18px;
            margin-bottom: 30px;
        }

        .sidebar_content li {
            margin-top: 20px;
        }

        .sidebar_content .md-field .md-input {
            font-size: 16px;
            padding: 6px;
            height: auto;
        }

        .sidebar_content .md-field label {
            bottom: 0 !important;
            top: unset !important;
        }

        .sidebar_content .md-field.md-focused label,
        .sidebar_content .md-field.md-has-value label {
            font-size: 14px;
            top: unset !important;
            bottom: 23px !important;
        }

        /*.sidebar_content .md-field .md-count {*/
        /*  font-size: 2.65vw;*/
        /*  height: 2.05vw;*/
        /*  bottom: -2.1vw;*/
        /*}*/
        /*.md-field.md-invalid .md-error {*/
        /*  font-size: 2.7vw;*/
        /*  line-height: 2.25vw;*/
        /*  height: 2vw;*/
        /*  bottom: -3vw;*/
        /*}*/
        .sidebar_content li img {
            margin-right: 7px;
            width: 22px
        }

    }

    @media screen and (max-width: 516px) {
        .sidebar_content li {
            margin-bottom: -20px;
        }

        .sidebar_title {
            margin-bottom: 10px;
        }
    }

</style>
